








































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Modal } from 'ant-design-vue'
import RiskSection from '@/views/AiiTasks/riskSection.vue'
import LawsuitApi from '@/api/lawsuit'
import TaskApi from '@/api/task'
import InvestigateApi from '@/api/investigate'
import { download, triggerWindowResizeEvent } from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import MediateApi from '@/api/mediate'
import bus from '@/views/AiiTasks/bus.ts'
import { ORDER_STATUS_DICT } from '@/web-task/config.ts'

@Component({
	components: {
		RiskSection,
	},
})
export default class DetailHeaderBtns extends Vue {
	private returnVisible: boolean = false
	private returnLoading: boolean = false
	private auditCancelVisible: boolean = false
	private auditCancelLoading: boolean = false
	private postponeVisible: boolean = false
	private postponeLoading: boolean = false
	private postponeHours: any = 12
	private revokeDialogVisible: boolean = false
	private cancelLoading: boolean = false
	private evaluateLoading: boolean = false
	private downloading: boolean = false
	private exporting: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private resurveyCountdown: any = 0
	private canResurvey: boolean = false
	public evaluateVisible: boolean = false
	public evaluateInfo: any = ''
	public evaluateForm: any = ''
	public rate: number = 5
	public labelMap: any = {}
	public labelList: any = []

	private cancelForm: any = {}
	private auditCancelForm: any = {}
	private returnForm: any = {}

	private mediateConfirm: any = ''

	private showRiskModal = false
	private DAI_ZHONG_SHEN: string = ORDER_STATUS_DICT.DAI_ZHONG_SHEN
	private DAI_QUE_REN_LAW: string = ORDER_STATUS_DICT.DAI_QUE_REN_LAW
	private DAI_JIE_DAN: string = ORDER_STATUS_DICT.DAI_JIE_DAN
	private YI_WAN_CHENG: string = ORDER_STATUS_DICT.YI_WAN_CHENG

	@Prop()
	private order!: any

	@Prop()
	private task!: any

	@Prop()
	private injured!: any

	@Prop()
	private riskList!: any

	@Watch('order', { immediate: true })
	private onOrderChange() {
		if (this.order) {
			this.getOrderExStatusInfo()
			this.evaluateInfo = ''
			this.getEvaluate()
		}
	}

	public getEvaluate(): any {
		if (!this.$route.params.orderId) {
			return
		}
		return EvaluateApi.getEvaluate({
			businessId: this.$route.params.orderId,
			evType: 'insurance',
		}).then((res: any) => {
			this.labelList = []
			this.labelMap = {}
			this.rate = 5
			this.evaluateForm.resetFields()
			if (res.data[0]) {
				this.evaluateInfo = res.data[0]
				this.labelList = res.data[0].labels
			}
		})
	}

	public evaluateOrder() {
		const id = this.evaluateInfo.id
		this.evaluateLoading = true
		EvaluateApi.saveEvaluate({
			id,
			userId: this.$store.state.user.userInfo.userId,
			urerName: this.$store.state.user.userInfo.userName,
			score: this.rate,
			comment: this.evaluateForm.getFieldValue('comment'),
			labels: this.labelList
				.map((item: any) => item.id)
				.filter((item: any) => this.labelMap[item]),
		})
			.then((res: any) => {
				this.$message.success('评价完成')
				this.evaluateVisible = false
				this.needRiskModal()
				this.getEvaluate()
			})
			.finally(() => {
				this.evaluateLoading = false
			})
	}

	private getDetail() {
		this.$emit('getDetail')
	}

	private auditTaskPass() {
		const order = this.order
		let passConfirm = this.$confirm({
			title: '提示',
			content: '确认审核通过吗 ?',
			onOk: () => {
				return LawsuitApi.lawsuitAudit({
					orderId: this.$route.params.orderId,
					pass: '1',
				}).then((res: any) => {
					this.$emit('getDetail')
					this.getEvaluate().then(() => {
						if (this.evaluateInfo.evStatus === '0') {
							this.evaluateVisible = true
						}
					})
				})
			},
		})
	}

	private isNeedMediate() {
		this.mediateConfirm = this.$confirm({
			title: '提示',
			content:
				'是否需要作业人员在线下进行调解，如果不需要则任务即可完成，如果需要请设置对应的调解金额。',
			onOk: () => {
				this.$emit('addMediateTab')
			},
			onCancel: () => {
				MediateApi.createConciliation(this.$route.params.orderId, '0', {}).then(
					(res: any) => {
						this.$emit('getDetail')
						this.getEvaluate().then(() => {
							if (this.evaluateInfo.evStatus === '0') {
								this.evaluateVisible = true
							}
						})
					}
				)
			},
			okText: '需要调解',
			cancelText: '不需要调解',
		})
	}

	public choose(i: any) {
		this.rate = i
	}

	public get canEvaluate() {
		const evStatus = this.evaluateInfo.evStatus
		const accessUserId = this.evaluateInfo.accessUserId
		if (evStatus && evStatus === '0') {
			if (accessUserId === this.$store.state.user.userInfo.userId) {
				return true
			}
			// 自动审核通过 有审核权限即可评价
			if (accessUserId === '-1') {
				if (
					this.order.creator === this.$store.state.user.userInfo.userId ||
					this.$auth('lawsuitDetail:audit')
				) {
					return true
				}
			}
		}
		return false
	}

	private closeEvaluate() {
		this.evaluateVisible = false
		this.needRiskModal()
	}

	private needRiskModal() {
		if (this.riskList && this.riskList.length) {
			this.showRiskModal = true
		}
	}

	// 获取是否展示复勘按钮
	private async getOrderExStatusInfo() {
		if (!this.$route.params.orderId) {
			return
		}
		const res = await TaskApi.getOrderExStatusInfo(this.$route.params.orderId)
		const data = res.data
		this.canResurvey = data.canCreateNewOrder && this.$auth('taskList:add')
		this.$emit('getEx', data)
		this.$nextTick(() => {
			triggerWindowResizeEvent()
		})
		if (data.lastSubmitTime) {
			const today = new Date(this.order.serverTime)
			const last = new Date(data.lastSubmitTime)

			const countdown = moment([
				today.getFullYear(),
				today.getMonth(),
				today.getDate(),
			]).diff(
				moment([last.getFullYear(), last.getMonth(), last.getDate()]),
				'days'
			)

			this.resurveyCountdown = countdown + 1
		} else {
			this.resurveyCountdown = false
		}
	}

	private auditTaskReturn() {
		this.returnForm.resetFields()
		this.returnVisible = true
	}

	private auditReturnSec() {
		this.returnVisible = false
		this.$emit('getDetail')
		this.$message.success('审核退回成功')
	}

	// 审核退回
	private returnOk() {
		this.returnForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.returnLoading = true
				if (this.order.orderStatus === '04') {
					// 终审退回
					LawsuitApi.lawsuitAudit({
						orderId: this.$route.params.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.auditReturnSec()
						})
						.finally(() => {
							this.returnLoading = false
						})
				}
			}
		})
	}

	private auditCancelReject() {
		this.auditCancelVisible = true
		this.auditCancelForm.resetFields()
	}

	// 拒绝撤单申请
	private deAuditCancel() {
		this.auditCancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.auditCancelLoading = true
				const copy = {
					...values,
					orderId: this.$route.params.orderId,
					pass: 0,
				}
				TaskApi.auditCancelTask(copy)
					.then((res: any) => {
						this.$message.success('撤单申请已拒绝')
						this.auditCancelVisible = false
						this.$emit('getDetail')
					})
					.finally(() => {
						this.auditCancelLoading = false
					})
			}
		})
	}

	// 同意撤单
	public auditCancelPass() {
		let operatorArrived = false
		if (this.order.applyCancels && this.order.applyCancels.length) {
			const apply = this.order.applyCancels.find(
				(item: any) => item.dataType === 'application'
			)

			operatorArrived = apply.type === '2'
		}
		const obj: any = {
			title: '提示',
			content: `确认同意撤单吗 ?`,
			onOk: () => {
				return TaskApi.auditCancelTask({
					orderId: this.$route.params.orderId,
					pass: 1,
				}).then((res: any) => {
					this.$message.success('撤单申请已同意')
					this.$emit('getDetail')
				})
			},
		}

		if (operatorArrived) {
			obj.content = (h: any) => {
				return h('div', {}, [
					h('div', '确认同意撤单吗 ?'),
					h(
						'div',
						{
							style: {
								color: '#E02020',
								marginTop: '6px',
							},
						},
						`注：因作业人员已到达作业地点，请认真审核撤单提交的资料是否属实，如撤单成功该任务会产生相应的费用！`
					),
				])
			}
		}

		this.$confirm(obj)
	}

	private resurvey() {
		this.$multiTab.close('/AiiTasks/addResurvey?resurvey=1')
		this.$ss.set(
			'resurveyOrder',
			{
				orderId: this.$route.params.orderId,
				insuranceType: this.order.insuranceType,
			},
			10 * 60 * 1000
		)
		this.$nextTick(() => {
			this.$router.push('/AiiTasks/addResurvey?resurvey=1')
		})
	}

	private postponeOrder() {
		this.postponeHours = 12
		this.postponeVisible = true
	}

	private postponeOk() {
		if (!this.postponeHours) {
			return this.$message.error('请选择订单延长时长')
		}
		this.postponeLoading = true
		return TaskApi.postponeOrder({
			orderId: this.$route.params.orderId,
			hours: this.postponeHours,
		})
			.then(() => {
				this.postponeVisible = false
				this.$message.success('延期成功')
				this.$emit('getDetail')
			})
			.finally(() => {
				this.postponeLoading = false
			})
	}

	private cancelOrder() {
		this.revokeDialogVisible = true
		this.cancelForm.resetFields()
	}

	private cancelOk() {
		this.cancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.cancelLoading = true
				const copy = {
					...values,
					orderId: this.$route.params.orderId,
				}
				LawsuitApi.cancelLawsuit(copy)
					.then((res: any) => {
						this.$message.success('撤销成功')
						this.revokeDialogVisible = false
						this.$emit('getDetail')
					})
					.finally(() => {
						this.cancelLoading = false
					})
			}
		})
	}

	private exportDocs() {
		this.downloading = true
		LawsuitApi.exportLawsuitOrderMedia(this.$route.params.orderId)
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.catch(err => {
				this.$message.error('只能导出已完成状态的订单')
			})
			.finally(() => {
				this.downloading = false
			})
	}

	private exportOrder() {
		this.exporting = true
		LawsuitApi.exportOrder(this.$route.params.orderId)
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exporting = false
			})
	}

	private getTaskLog() {
		TaskApi.getTaskLog(this.$route.params.orderId).then((res: any) => {
			this.taskLog = res.data
			this.taskLogVisible = true
		})
	}

	private checkRelated() {
		this.$router.push(`/lawsuit/taskDetail/${this.order.parentOrderId}`)
	}

	private createRelated(taskType: string) {
		this.$multiTab.close('/lawsuit/addTask')
		this.$nextTick(() => {
			this.$router.push({
				name: 'addLawsuitTask',
				params: {
					taskType: taskType,
					relatedOrderNo: this.order.orderNo,
				},
			})
		})
	}

	private beforeDestroy() {
		bus.$off('showEvaluate')
	}

	private activated() {
		bus.$on('showEvaluate', () => {
			this.getEvaluate().then(() => {
				if (this.evaluateInfo.evStatus === '0') {
					this.evaluateVisible = true
				}
			})
		})
	}

	private deactivated() {
		bus.$off('showEvaluate')
	}

	private created() {
		this.cancelForm = this.$form.createForm(this)
		this.auditCancelForm = this.$form.createForm(this)
		this.returnForm = this.$form.createForm(this)
		this.evaluateForm = this.$form.createForm(this)
	}
}
